// extracted by mini-css-extract-plugin
module.exports = {"image":"_32bbee5fda--image--N_JrJ","image--layout":"_32bbee5fda--image--layout--xmTp3"};